<ol class="breadcrumb">
  <li class="breadcrumb-item" *ngFor="let item of items">
    <a [routerLink]="[item.url]"><span>{{ item.breadcrumb }}</span></a>
  </li>
</ol>